export const PATHS = {
  // Default
  DEFAULT: "/",

  // Auth
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  OTP_DETAILS: "/otp-details",
  OTP_VERIFICATION: "/otp-verification",
  DELETE_ACCOUNT: "/delete-account",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_CONDITIONS: "/terms-and-conditions",

  // Dashboard Module
  DASHBOARD: "/dashboard",

  // User management
  USER: "users",
  USER_LIST: "individual-users",
  USER_DETAILS: "user-details",
  ADMIN_USER: "admin-users",
  BUSINESS_USER_LIST: "business-users",
  PERSONAL_DETAILS: "personal-details",
  BUSINESS_USER_DETAILS: "business-user-details",
  //Property Mangement
  PROPERTY: "property",
  PROPERTY_LIST: "property-list",
  PROPERTY_DIVIDENDS: "property-dividends",
  PROPERTY_SALES_NOTIFICATION: "property-sales-notification",
  SALES_PROCEEDS: "sales-proceeds",
  //Gems
  GEMS: "gems",
  GEMS_LIST: "gems-list",
  GEMS_DIVIDENDS: "gems-dividends",
  GEMS_SALES_NOTIFICATION: "gems-sales-notification",
  GEMS_SALES_PROCEEDS: "gems-sales-proceeds",

  //Investment
  INVESTMENT: "investment",
  INVESTMENT_PROPERTY: "investment-property",
  INVESTMENT_GEMS: "investment-gems",
  //Transaction Window
  TRANSACTIONS: "transactions",
  DEPOSITS: "deposits",
  WITHDRAWALS: "withdrawals",
  REFERRAL_REWARDS: "referral_rewards",
  //Investment
  EXIT_WINDOW: "window",
  EXIT_WINDOW_PROPERTY: "exit-window-property",
  EXIT_WINDOW_GEMS: "exit-window-gems",
  EXIT_WINDOW_PROPERTY_BUYER: "exit-window-property-buyer",

  // Role
  ROLE: "/role",

  // Support
  SUPPORT: "/support",
  //LESG Logs
  LESG_LOGS: "lesg-logs",
  // Master management
  MASTER_MANAGEMENT: "/master",
  COUNTRY: "country",
  TIMEZONE: "timezone",
  LANGUAGE: "language",
  AMENITIES: "amenities",
  SUBSIDARIES: "subsidaries",
  GEMSTONE_TYPE: "gemstone-type",
  INDUSTRIES: "industries",
  ROLES_LIST: "roles-list",
  PROPERTY_TYPE: "property-type",
  //contact us
  CONTACT_US: "contact_us",
  // Reports
  REPORTS: "/reports",
  DAILY_USER_REPORT: "daily-user-report",
  TRANSACTION_REPORT: "transaction-report",
  // Email And Notification
  EMAIL_TEMPLATES: "/email-templates",
  // Content management
  CONTENT: "/content",
  STATIC_PAGES: "static-pages",
  BLOGS: "blogs",
  BLOG_LIST: "blog-list",
  BLOG_CATEGORY: "blog-category",
  BLOG_CATEGORY_VIEW: "/blog-category-details/:id",
  FAQS: "faqs",
  FAQS_LIST: "faq-list",
  FAQS_CATEGORY: "faq-category",
  CMS_PAGES: "cms-pages",
  //Contact Us
  CONTACT_US: "contact-us",
  // Settings
  SETTINGS: "/settings",
  GENERAL_SETTINGS: "general-settings",
  NOTIFICATIONS: "notifications",
  SOCIAL_MEDIA: "social-media",
  PAYMENT_GATEWAY: "payment-gateway",
  SMTP_SMS_DETAILS: "smtp-details",
  EMAIL_NOTIFICATIONS: "email-notifications",
  LANGUAGE_MESSAGES: "language/messages",
  LANGAUGE_STATIC_LANG: "language/static-label",
  //Archived
  ARCHIVED: "archived-users",

  // Common Pages
  FourZeroFour: "/common/404",
  THANKYOU: "/common/thankyou",
  COMING_SOON: "/common/coming-soon",

  // Profile
  MY_PROFILE: "/profile",
  EDIT_MY_PROFILE: "/profile/edit-profile",

  // Change Password
  CHANGE_PASSWORD: "/change-password",

  // Ui Kit
  UI_KIT: "/uikit",
  TYPOGRAPHY: "typography",
  COLORS: "colors",
  FORMS: "forms",
  CARDS: "cards",
  BLOCKS: "blocks",
  // Extras
  ANY: "*",
  VIEW: "view",
  CREATE: "create",
  EDIT: "edit",
};
